<div *ngIf="showCtrl">
  <div [class]="outerClass" [ngClass]="tintClass" [@showState]="showState">
    <!-- <div class="text-center"> -->
    <div class="info-text-m bold" [ngClass]="innerClass">{{data}}</div>
    <!-- </div> -->
  </div>
</div>